<template>
    <b-modal
        ref="uploadLogo"
        title="Upload Logo"
        centered
        @hidden="openAddStore">
        <div id="organization-image-upload-container" class="border mx-auto">
            <croppa
                v-model="store.logo.croppa"
                @new-image-drawn="logoOnNew"
                @zoom="logoOnZoom"
                :width="200"
                :height="200"
                placeholder="Choose an Image"
                :show-remove-button="true"
                :placeholder-font-size="14"
                :prevent-white-space="true"
                remove-button-color="#ff8828"></croppa>
        </div>
        <div id="organization-image-range-container" class="mx-auto mt-2">
            <input
                type="range"
                class="custom-range"
                id="customRange1"
                @input="logoOnSliderChange"
                :min="store.logo.sliderMin"
                :max="store.logo.sliderMax"
                step=".001"
                v-model="store.logo.sliderValue"
            >
        </div>
        <div slot="modal-footer">
            <b-button
                variant="secondary"
                style="margin-right: .25rem;"
                @click="cancelLogo">
                Cancel
            </b-button>
            <b-button
                variant="primary"
                style="margin-left: .25rem;"
                @click="setLogo">
                Save
            </b-button>
        </div>
    </b-modal>
</template>

<script>
export default {
    name: "CustomerStoreLogo",
    props: [
        "open",
        "openType"
    ],
    data() {
        return {
            store: {
                logo: {
                    coppa: {},
                    sliderValue: null,
                    sliderMin: null,
                    sliderMax: null,
                },
                mode: null
            }
        };
    },
    methods: {
        logoOnNew() {
            this.store.logo.sliderValue = this.store.logo.croppa.scaleRatio;
            this.store.logo.sliderMin = this.store.logo.croppa.scaleRatio / 2;
            this.store.logo.sliderMax = this.store.logo.croppa.scaleRatio * 2;
        },
        logoOnZoom() {
            this.store.logo.sliderValue = this.store.logo.croppa.scaleRatio;
        },
        logoOnSliderChange(e) {
            let increment = e.target.value;
            this.store.logo.croppa.scaleRatio = +increment;
        },
        cancelLogo() {
            switch(this.store.mode) {
                case "new":
                    this.openAddStore();
                    break;
                case "update":
                    this.openEditStore();
                    break;
            }
        },
        setLogo: async function(type) {
            let image = this.store.logo.croppa.generateDataUrl();
            await this.$emit("croppaLogo", image);
            this.cancelLogo();
        },
        openAddStore: async function() {
            await this.$refs.uploadLogo.hide();
            this.$emit("openAddStore");
        },
        openEditStore: async function() {
            await this.$refs.uploadLogo.hide();
            this.$emit("openEditStore");
        }
    },
    watch: {
        open: function(value) {
            if(value === true) {
                this.$refs.uploadLogo.show();
            }
        },
        openType: function(value) {
            this.store.mode = value;
        }
    }
}
</script>

<style>

</style>
